<script lang="ts">
  import { Button, Col, Image, Label, Row } from "sveltestrap";
  import { CashOnDelivery, CheckPayments, PayPal, PlaceOrder } from "../../../../utils/Constant/Constant";
  let imgPath:string = "/assets/images/checkout"
</script>
<div class="animate-chk">
  <Row>
    <Col>
      <Label class="d-block" for="edo-ani">
        <input class="radio_animated" id="edo-ani" type="radio" name="rdo-ani" checked />{CheckPayments}
      </Label>
      <Label class="d-block" for="edo-ani1">
        <input class="radio_animated" id="edo-ani1" type="radio" name="rdo-ani" />{CashOnDelivery}
      </Label>
      <Label class="d-block" for="edo-ani2">
        <input class="radio_animated" id="edo-ani2" type="radio" name="rdo-ani" checked />{PayPal}
        <Image class="img-paypal" src="{imgPath}/paypal.png" />
      </Label>
    </Col>
  </Row>
</div>
<div class="order-place">
  <Button color="primary" href="/ecommerce/invoice">{PlaceOrder}</Button>
</div>